function secureMaskDocument(document: string): string {
  const firstPart: string = document.substring(0, 3);
  const lastPart: string = document.substring(document.length - 3);
  const maskedPart: string = '*'.repeat(document.length - 6);
  return `${firstPart}${maskedPart}${lastPart}`;
}

export default secureMaskDocument;
